import { Component, OnInit, ViewChild } from "@angular/core";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import {
  AppFields,
  AppState,
  AutoUnsubscribe, filter, Store, take,
} from "../store";
import { ActivatedRoute } from "@angular/router";
import { DevelopmentCalendarService } from "../../../services/development-calendar.service ";
import {
  EventSettingsModel,
  DayService,
  WeekService,
  WorkWeekService,
  MonthService,
  AgendaService,
  MonthAgendaService,
  TimelineViewsService,
  TimelineMonthService,
  RenderCellEventArgs,
  PopupOpenEventArgs,
  EventRenderedArgs,
} from "@syncfusion/ej2-angular-schedule";
import { MyTeamsService } from "../../../services";

@Component({
  selector: "app-team-development-calendar-player",
  templateUrl: "./development-calendar-player.component.html",
  styleUrls: ["./development-calendar-player.component.css"],
  providers: [
    DayService,
    WeekService,
    WorkWeekService,
    MonthService,
    AgendaService,
    MonthAgendaService,
    TimelineViewsService,
    TimelineMonthService,
  ],
})
@AutoUnsubscribe
export class DevelopmentCalendarPlayerComponent implements OnInit {
  public teamID: number = 0;
  public playerID: number = 0;

  public showCalendar: boolean = false;

  public showVenueTypes: boolean = false;

  public links: { title: string; url: any }[] = [];

  @ViewChild("scheduleObj")
  public scheduleObj;

  public eventSettings: EventSettingsModel = {
    dataSource: null,
    fields: {
      id: "id",
      subject: { name: "subject" },
      startTime: { name: "startDate" },
      endTime: { name: "endDate" },
      isAllDay: { name: "isAllDay" },
    },
  };

  public selectedDateTime = new Date();
  public selectedYear: number = new Date().getFullYear();
  public selectedMonth: number = new Date().getMonth() + 1;

  public selectYearOptions = Array.from(
    Array(5),
    (x, i) => this.selectedYear - i
  );

  dashboardResult = null;

  manualWorkouts = [];
  playerMoodDaily = [];
  workoutsAssigned = [];
  videoAssigned = [];
  injuryAssigned = [];
  gamesAssigned = [];
  daysOffAssigned = [];
  playerMoodRates = [];

  isWorkoutsAssignedChecked: boolean = true;
  isManualWorkoutsChecked: boolean = true;
  isVideoAssignedChecked: boolean = true;
  isInjuryAssignedChecked: boolean = true;
  isPlayerMoodDaily: boolean = true;
  isGamesAssignedChecked: boolean = true;
  isDaysOffAssignedChecked: boolean = true;
  isPracticeChecked: boolean = true;

  allSchedulerData = [];
  allSchedulerDataCopy = [];
  showDevelopmentCalendar: boolean = false;
  developmentScheduler: any;
  playerPractices: any;
  selectedGame: any;
  gameDetailFlyoutOpen: boolean;
  gameTitle: string;
  practiceDetailFlyoutOpen: boolean;
  selectedPractice: any;

  club: any;
  statusList: string[] = ['Not Attending', 'Attending', 'Possibly Missing', 'Injured'];
  injuryDetailFlyoutOpen: boolean;
  selectedInjury: any;

  constructor(
    private _service: DevelopmentCalendarService,
    private teamService: MyTeamsService,
    private _spinner: Ng4LoadingSpinnerService,
    private activeRoute: ActivatedRoute,
    private store: Store<AppState>
  ) {
    this.teamID = +this.activeRoute.snapshot.params.teamID;
    this.playerID = +this.activeRoute.snapshot.params.playerID;

    this.links = [
      {
        title: "SELECT A PLAYER",
        url: "/team-development-calendar/all-players",
      },
      { title: "DETAILS", url: null },
    ];
  }

  ngOnInit() {
    this.loadDevelopmentCalendarByTeamAndPlayerID(this.teamID, this.playerID, this.selectedYear, this.selectedMonth);
    this.loadDevelopmentCalendarPlayerMood(this.teamID, this.playerID, this.selectedYear);

    
    this.store.select(AppFields.App, AppFields.Club).pipe(
      filter(p => !!p),
      take(1)
    ).subscribe(club => {
      this.club = club;
    });
  }

  loadDevelopmentCalendarByTeamAndPlayerID( teamID: number, playerID: number, selectedYear: number, selectedMonth: number) {
    //Empty Array
    //this.allSchedulerData.splice(0, this.allSchedulerData.length);
    this.allSchedulerData.length = 0;

    this._spinner.show();
    this._service.loadDevelopmentCalendarByTeamAndPlayerID(teamID, playerID, selectedYear, selectedMonth)
      .subscribe(
        (res) => {
          this.dashboardResult = res;
          console.log("loadDevelopmentCalendarByTeamAndPlayerID   ===>  ", res);
          this.developmentScheduler = res.developmentScheduler;
          this.setDevelopmentCalendarData();
          this.showDevelopmentCalendar = true;
          this._spinner.hide();
        },
        () => {
          this._spinner.hide();
        }
      );
  }

  onEventSelect({ data }) {
    this.onCancel();

    if (data.type === 'game') {
      this._spinner.show();
      this._service.loadGameData(this.teamID, this.playerID, data.id).subscribe((res) => {
        this.gameDetailFlyoutOpen = true;
        this.selectedGame = {
          ...res,
          gameDate: new Date(res.gameDate),
          gameDate1: new Date(res.gameDate1),
        };
        if (res.awayteamID === this.teamID) {
          this.gameTitle = `Game vs. ${res.homeTeam}`
        } else {
          this.gameTitle = `Game vs. ${res.awayTeam}`
        }
        this._spinner.hide();
      });
    } else if (data.type === 'practice') {
      this._spinner.show();
      this._service.loadPracticeData(this.teamID, this.playerID, data.id).subscribe(res => {
        this.practiceDetailFlyoutOpen = true;
        this.selectedPractice = {
          ...res,
          startDate: new Date(res.startDate),
          endDate: new Date(res.endDate),
        };
        this._spinner.hide();
      });
    } else if (data.type === 'injury') {
      this._spinner.show();
      this._service.loadInjuryData(data.id).subscribe(res => {
        this.injuryDetailFlyoutOpen = true;
        this.selectedInjury = res;
        this._spinner.hide();
      });
    }
  }

  loadDevelopmentCalendarPlayerMood(teamID: number, playerID: number, selectedYear: number) {
    this._service
      .loadDevelopmentCalendarPlayerMood(teamID, playerID, selectedYear)
      .subscribe(
        (res) => {
          this.playerMoodRates = res;
        },
        () => { }
      );
  }

  setDevelopmentCalendarData() {
    this.allSchedulerData = [];

    this.workoutsAssigned = this.developmentScheduler.workoutsAssigned;
    if (this.isWorkoutsAssignedChecked) {
      this.allSchedulerData.push(...this.workoutsAssigned.map(a => ({
        ...a,
        color: '#85A4A3',
        type: 'workout'
      })));
    }
  
    this.manualWorkouts = this.developmentScheduler.manualWorkouts;
    if (this.isManualWorkoutsChecked) {
      this.allSchedulerData.push(...this.manualWorkouts.map(a => ({
        ...a,
        color: 'rgb(11, 247, 230)',
        type: 'manual-workout'
      })));
    }

    this.videoAssigned = this.developmentScheduler.videoAssigned;
    if (this.isVideoAssignedChecked) {
      this.allSchedulerData.push(...this.videoAssigned.map(a => ({
        ...a,
        color: '#8BCAED',
        type: 'video'
      })));
    }

    this.injuryAssigned = this.developmentScheduler.injuryAssigned;
    if (this.isInjuryAssignedChecked) {
      this.allSchedulerData.push(...this.injuryAssigned.map(a => ({
        ...a,
        color: '#D0695F',
        type: 'injury'
      })));
    }

    this.playerMoodDaily = this.developmentScheduler.playerMoodDaily;
    // this.isPlayerMoodDaily = true;

    this.gamesAssigned = this.developmentScheduler.gameAssigned || [];
    if (this.isGamesAssignedChecked) {
      this.allSchedulerData.push(...this.gamesAssigned.map(a => ({
        ...a,
        color: '#3D444E',
        type: 'game'
      })));
    }

    this.daysOffAssigned = this.developmentScheduler.daysOff;
    if (this.isDaysOffAssignedChecked) {
      this.allSchedulerData.push(...this.daysOffAssigned.map(a => ({
        ...a,
        color: '#B1B1B2',
        type: 'dayoff'
      })));
    }

    this.playerPractices = this.developmentScheduler.playerPractices;
    if (this.isPracticeChecked) {
      this.allSchedulerData.push(...this.playerPractices.map(a => ({
        ...a,
        color: '#5E82CE',
        type: 'practice'
      })));
    }

    this.setAllSchedulerDataToScheduler(this.allSchedulerData);
  }

  onMonthlyTotalDateChange(args) {
    var selectedDate = new Date(args.value);

    const selectedMonth = selectedDate.getMonth() + 1;
    const selectedYear = selectedDate.getFullYear();

    // this.dashboardResult = null;
    this.showDevelopmentCalendar = false;
    this.loadDevelopmentCalendarByTeamAndPlayerID(
      this.teamID,
      this.playerID,
      selectedYear,
      selectedMonth
    );

    this.selectedDateTime = new Date(selectedYear, selectedMonth - 1, 15);
  }

  public isShowWorkoutSummary: boolean = false;
  public selectedWorkouts: any;
  public subTitle: string = '';

  onPopupOpen(args: PopupOpenEventArgs): void {
    console.log("ARGS   =>   ", args.type);
    if (args.type === 'EventContainer') {
      console.log("ARGS DATA  =>  ", args.data);
    }
    else if (args.type === 'QuickInfo') {
      console.log("ARGS DATA (QuickInfo) =>  ", args.data);
      this.selectedWorkouts = (<{ [key: string]: Object }>(args.data)).workouts

      if (this.selectedWorkouts) {
        this.isShowWorkoutSummary = true;
        this.subTitle = (<{ [key: string]: Object }>(args.data)).subject as string;
      }

      args.cancel = true;
    }
    else {
      // args.cancel = true
    }
  }

  onCancel() {
    this.isShowWorkoutSummary = false;
    this.selectedGame = null;
    this.gameDetailFlyoutOpen = false;

    this.injuryDetailFlyoutOpen = false;
    this.selectedInjury = null

    this.selectedPractice = null;
    this.practiceDetailFlyoutOpen = false;
  }

  onRenderCell(args: RenderCellEventArgs): void {
    if (!this.isPlayerMoodDaily) {
      return;
    }
    const timeDay = args.date.getDate();
    const timeMonth = args.date.getMonth() + 1;

    //check if mood is in day and month
    const found = this.playerMoodDaily.some(
      (el) => el.day === timeDay && el.month === timeMonth
    );
    if (found === true) {
      if (args.elementType == "workCells" || args.elementType == "monthCells") {
        const foundElement = this.playerMoodDaily.filter(
          (el) => el.day === timeDay && el.month === timeMonth
        )[0];
        let ele: HTMLElement = document.createElement("DIV");
        ele.innerHTML = "<span style='position:right'><img width='30px;' height='30px;' src='" +
          foundElement.moodUrl + "' /></span>";
        ele.className = "templatewrap";
        args.element.appendChild(ele);
      }
    }
  }

  onActionComplete(event) {
    console.log(event.requestType);
    if (event.requestType === "dateNavigate") {
      this.showDevelopmentCalendar = false;

      var currentViewDates = this.scheduleObj.getCurrentViewDates();
      const middle =
        currentViewDates[Math.round((currentViewDates.length - 1) / 2)];
      this.selectedYear = new Date(middle.toString()).getFullYear();
      this.selectedMonth = new Date(middle.toString()).getMonth() + 1;

      this.selectedDateTime = new Date(
        this.selectedYear,
        this.selectedMonth - 1,
        15
      );

      this.setAllSchedulerDataToScheduler([]);

      //Call API to Update UI
      this.loadDevelopmentCalendarByTeamAndPlayerID(
        this.teamID,
        this.playerID,
        this.selectedYear,
        this.selectedMonth
      );
    }
  }

  setAllSchedulerDataToScheduler(allSchedulerData: any[]) {
    this.eventSettings = {
      dataSource: <Object[]>allSchedulerData,
      fields: {
        id: "id",
        subject: { name: "subject" },
        startTime: { name: "startDate" },
        endTime: { name: "endDate" },
        isAllDay: { name: "isAllDay" },
      },
    };
  }

  onSelectedYearChanged(selectedYear) {
    console.log("Selected Year => ", selectedYear);
    this.loadDevelopmentCalendarPlayerMood(
      this.teamID,
      this.playerID,
      selectedYear
    );
  }

  onEventRendered(args: EventRenderedArgs): void {
    let categoryColor: string = args.data.color as string;
    if (!args.element || !categoryColor) {
      return;
    }
    if (this.scheduleObj.currentView === "Agenda") {
      (args.element
        .firstChild as HTMLElement).style.borderLeftColor = categoryColor;
    } else {
      args.element.style.backgroundColor = categoryColor;
    }

    // let cellHeight = (document.querySelectorAll(".e-work-cells")[0] as any)
    //   .offsetHeight;
    // args.element.style.height = "" + cellHeight + "px";
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/team-development-calendar/development-calendar-player/development-calendar-player.component.ts